/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.frequentBuyerPrograms.internal

import features.frequentBuyerPrograms.models.FrequentBuyerProgramsModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class FrequentBuyerProgramsRequest : NetworkRequest() {

    suspend fun getFrequentBuyerPrograms(
        overrideHeaders: Map<String, String>? = null,

    ): IOResult<FrequentBuyerProgramsModel> {
        return safeNetworkCall {
            get(
                endpoint = FrequentBuyerProgramsEndpoint,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
